<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="cate_1"
                          label="一级类目">
              <el-input v-model="form.cate_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="cate_2"
                          label="二级类目">
              <el-input v-model="form.cate_2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="yzlm"
                          label="叶子类目">
              <el-input v-model="form.yzlm"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label-width
                          prop="create_time"
                          label="统计日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker v-model="form.create_time"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="统计日期"
                       width="100px"></el-table-column>
      <el-table-column prop="cate_1"
                       align="center"
                       header-align="center"
                       label="一级类目"></el-table-column>
      <el-table-column prop="cate_2"
                       align="center"
                       header-align="center"
                       label="二级类目"></el-table-column>
      <el-table-column prop="yzlm"
                       align="center"
                       header-align="center"
                       label="叶子类目"></el-table-column>
      <el-table-column prop="zfje"
                       align="center"
                       header-align="center"
                       label="支付金额"></el-table-column>
      <el-table-column prop="visitor"
                       align="center"
                       header-align="center"
                       label="访客数"></el-table-column>
      <el-table-column prop="wxdfks"
                       align="center"
                       header-align="center"
                       label="无线端访客数"></el-table-column>
      <el-table-column prop="pcdfks"
                       align="center"
                       header-align="center"
                       label="PC端访客数"></el-table-column>
      <el-table-column prop="pcdzfje"
                       align="center"
                       header-align="center"
                       label="PC端支付金额"></el-table-column>
      <el-table-column prop="wxdzfje"
                       align="center"
                       header-align="center"
                       label="无线端支付金额"></el-table-column>
      <el-table-column prop="zfmjs"
                       align="center"
                       header-align="center"
                       label="支付买家数"></el-table-column>
      <el-table-column prop="pcdzfmjs"
                       align="center"
                       header-align="center"
                       label="PC端支付买家数"></el-table-column>
      <el-table-column prop="wxdzfmjs"
                       align="center"
                       header-align="center"
                       label="无线端支付买家数"></el-table-column>
      <el-table-column prop="zfzhlv"
                       align="center"
                       header-align="center"
                       label="支付转化率"></el-table-column>
      <el-table-column prop="pcdzfzhlv"
                       align="center"
                       header-align="center"
                       label="PC端支付转化率"></el-table-column>
      <el-table-column prop="wxdzfzhlv"
                       align="center"
                       header-align="center"
                       label="无线端支付转化率"></el-table-column>
      <el-table-column prop="zfsps"
                       align="center"
                       header-align="center"
                       label="支付商品数"></el-table-column>
      <el-table-column prop="pcdzfsps"
                       align="center"
                       header-align="center"
                       label="PC端支付商品数"></el-table-column>
      <el-table-column prop="wxdzfsps"
                       align="center"
                       header-align="center"
                       label="无线端支付商品数"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/canmou/shopcatedaily/index.vue